import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Header from './components/Header'
import Hero from './components/Hero'
import About from './components/About'
import Experience from './components/Experience'
import Projects from './components/Projects'
import Skills from './components/Skills'
import Contact from './components/Contact'
import JobApplicationAgentPage from './components/JobApplicationAgentPage'
import FitnessTrainerPage from './components/FitnessTrainerPage'
import EasyResumePage from './components/EasyResumePage'
import KitchenRotaPage from './components/KitchenRotaPage'
import AudioSynthesisPage from './components/AudioSynthesisPage'
import PptMakerPage from './components/PptMakerPage'

function HomePage() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <About />
        <Experience />
        <Projects />
        <Skills />
        <Contact />
      </main>
    </>
  )
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/projects/job-application-agent" element={<JobApplicationAgentPage />} />
        <Route path="/projects/fitness-trainer" element={<FitnessTrainerPage />} />
        <Route path="/projects/easy-resume" element={<EasyResumePage />} />
        <Route path="/projects/kitchen-rota" element={<KitchenRotaPage />} />
        <Route path="/projects/audio-synthesis" element={<AudioSynthesisPage />} />
        <Route path="/projects/ppt-maker" element={<PptMakerPage />} />
      </Routes>
    </BrowserRouter>
  )
}
